var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelVine14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.5 7.54c-.864 0-1.529-.617-1.529-1.69 0-.525.199-.799.48-.799.267 0 .446.246.446.743 0 .283-.075.594-.13.777 0 0 .267.475.995.33A3.2 3.2 0 0 0 10 5.695C10 4.624 9.465 4 8.485 4c-1.007 0-1.597.792-1.597 1.837 0 1.034.473 1.922 1.253 2.327a6.7 6.7 0 0 1-1.18 1.707c-.79-.976-1.503-2.278-1.796-4.82H4c.538 4.233 2.142 5.58 2.566 5.84.24.147.446.14.666.013.344-.2 1.378-1.257 1.95-2.495.241-.001.53-.03.818-.096V7.48c-.176.042-.347.06-.5.06"
}))));
export default SvgChannelVine14;